import styled from "styled-components"

export const Wrapper = styled.section`
  position: fixed;
  bottom: ${({ isOpen }) => isOpen ? '0' : '-100%'};
  left: 0;
  right: 0;
  height: auto;
  padding: 10px 3px 0;
  background-color: var(--offWhite);
  z-index: 15;

  transition: all ease 0.3s;
  // user-select: none;

  ${({ theme }) => theme.mq.atTablet`
    padding:10px 3px 0;    
  `}
  ${({ theme }) => theme.mq.atDesktop`
    padding: 10px 3px 0;    
  `}

  & > h2 {
    ${({ theme }) => theme.text.medium}
    margin-left: 10px;
    margin-bottom: 0;
  }

`

export const RowWrapper = styled.div`
  display: flex;
  flex-wrap: nowrap;
  overflow-x: scroll;
  padding-bottom: 95px;
  padding-top: 10px;

  ${({ theme }) => theme.mq.atTablet`
  padding-bottom: 90px;
  padding-top: 10px;
  `}
  ${({ theme }) => theme.mq.atDesktop`
    padding-bottom: 30px;
    padding-top: 30px;
  `}

  & > div {
    width: 45%;
    min-width: 200px;
    margin: 0 10px;
    height: 150px;

    ${({ theme }) => theme.mq.atTablet`
      width:  22%;
    `}
    
  }

`

export const ToggleButton = styled.div`
    position: fixed;
    bottom: 20px;
    left: 25%;
    transform: translateX(-50%);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: ease 0.4s;
    z-index: 20;

    ${({ theme }) => theme.mq.atDesktop`
      bottom: 5vh;
      left: 90%;
    `}

    &:hover {
      & > div {background-color: #E9F2FF;}
    }

    & > div {
      display: flex;
      position: relative;
      height: 60px;
      width: 60px;
      border-radius: 50%;
      box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.1);
      align-items: center;
      justify-content: center;

      transform: ${({ status }) => (status ? "scale(33)" : "scale(1)")};
      transition: transform 0.4s ease;
      background-color: var(--offWhite);
      z-index: -1;
      ${({ theme }) => theme.mq.atTablet`
        transform: ${({ status }) => (status ? "scale(40)" : "scale(1)")};
      `}

    }


`

export const Counter = styled.span`
  top: -5px;
  right: -5px;
  position: absolute;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: var(--blue);
  height: 27px;
  width: 27px;
  border-radius: 50%;
  ${({ theme }) => theme.text.small}
  color: white;

`

export const EmptyList = styled.p`
  display: flex;
  padding: 30px 14px 95px;
  text-align: center;
  ${({ theme }) => theme.text.small}

  & > #infoIcon {
    height: 21px;
    margin-left: 10px;
    margin-right: 10px;
  }

`
